import { decryptData } from "../utils/Helpers";
import {
  USER_DATA,
  IS_DARK,
  IS_TOGGLE,
  ACCESS_MODULE,
  SIDEBAR_TOGGLE,
  DELETE_LENGTH,
  SIDEBAR_TOGGLE_RESP,
  IS_MODAL,
  ACCESS_TOKEN,
  setCourseId,
  COURSE_ID,
  CLIENT_ID,
  CLIENT_VIEW_ID,
  ERROROBJ,
  ERRORPOPMSG,
  LANGUAGEID,
  SELECTLANG,
  SELECTLANGJSON,
  LANGUAGES,
  PROFILEUPDATE,
  PROFILEDATA,
  PROFILEDETAIL,
  ONBAORDING,
  NEWUSER,
  LANGUAGEDATA,
  DEFAULTLANGUAGE,
  ISCOMPLETESTATUS,
} from "./actionTypes";
import CryptoJS from "crypto-js";

const secretKeyMain = "rmAdminSecretKey";
let data = decryptData(localStorage.getItem("rainClientData"));
let userDataClient =
  decryptData(localStorage.getItem("rainClientUserData")) || {};

let userDataDetail =
  decryptData(localStorage.getItem("rainClientUserDetail")) || {};
let theme = localStorage.rainClientTheme;
let isCompleteStatus = localStorage.isCompleteStatus || false;
// let clientOnBoarding = localStorage.rainClientOnBoarding;
const encryptedAccessToken = localStorage.getItem("rainClientToken");
const defaultLanguage = localStorage.getItem("defaultLanguage");
// let access_token = localStorage.rainClientToken?.toString();
let access_token = null;
if (encryptedAccessToken) {
  try {
    const bytes = CryptoJS.AES.decrypt(encryptedAccessToken, secretKeyMain);
    access_token = bytes.toString(CryptoJS.enc.Utf8);
  } catch (error) {
    console.error("Access token decryption error:", error);
  }
}
// let rainCourseId = localStorage.rainCourseId;
const encryptedCourseId = localStorage.getItem("rainCourseId");
// let access_token = localStorage.rainClientToken?.toString();
let rainCourseId = null;
if (encryptedCourseId) {
  try {
    const bytes = CryptoJS.AES.decrypt(encryptedCourseId, secretKeyMain);
    rainCourseId = bytes.toString(CryptoJS.enc.Utf8);
  } catch (error) {
    console.error("Access token decryption error:", error);
  }
}
let rainClientId = null;
let encryptedRainClientId = window.localStorage.getItem("rainClientId");
if (encryptedRainClientId) {
  try {
    const bytes = CryptoJS.AES.decrypt(encryptedRainClientId, secretKeyMain);
    rainClientId = bytes.toString(CryptoJS.enc.Utf8);
  } catch (error) {
    console.error("Access token decryption error:", error);
  }
}

let rainCourseViewId = decryptData(localStorage.getItem("rainCourseViewId"));
let languages = decryptData(localStorage.getItem("clientLanguagesObj")) || [];
const storedData = localStorage?.getItem("languageData");
const languageData = storedData ? JSON?.parse(storedData) : [];
let rainClientLang = null;
let encryptedSelectLang = window.localStorage.getItem("rainClientLang");
if (encryptedSelectLang) {
  try {
    const bytes = CryptoJS.AES.decrypt(encryptedSelectLang, secretKeyMain);
    rainClientLang = bytes.toString(CryptoJS.enc.Utf8);
  } catch (error) {
    console.error("Access token decryption error:", error);
  }
}



const initialState = {
  userData: data,
  isDark: theme,
  accessModule: data?.data?.permissions,
  isSidebarToggle: false,
  deleteLength: [],
  sidebarIsOpen: false,
  isModal: false,
  access_token: access_token,
  courseId: rainCourseId,
  clientId: rainClientId,
  courseViewId: rainCourseViewId,
  errorPop: false,
  errorPopMsg: null,
  languageId: "",
  selectLang: rainClientLang,
  selectLangJson: {},
  languages: languages,
  profileUpdate: 1,
  profileData: userDataClient,
  profileDetail: userDataDetail,
  isOnBoardingSet: false,
  newUser: false,
  languageData: languageData,
  defaultLanguage: defaultLanguage ,
  isCompleteStatus: isCompleteStatus
};

const customReducer = (state = initialState, { type, data }) => {
  switch (type) {
    case USER_DATA:
      return {
        ...state,
        userData: data,
      };
    case IS_DARK:
      return {
        ...state,
        isDark: data,
      };
    case IS_TOGGLE:
      return {
        ...state,
        isToggle: data,
      };
    case ACCESS_MODULE:
      return {
        ...state,
        accessModule: data,
      };
    case SIDEBAR_TOGGLE:
      return {
        ...state,
        isSidebarToggle: data,
      };
    case DELETE_LENGTH:
      return {
        ...state,
        deleteLength: data,
      };
    case SIDEBAR_TOGGLE_RESP:
      return {
        ...state,
        sidebarIsOpen: data,
      };
    case IS_MODAL:
      return {
        ...state,
        isModal: data,
      };
    case ACCESS_TOKEN:
      return {
        ...state,
        access_token: data,
      };
    case CLIENT_ID:
      return {
        ...state,
        clientId: data,
      };
    case COURSE_ID:
      return {
        ...state,
        courseId: data,
      };
    case CLIENT_VIEW_ID:
      return {
        ...state,
        courseViewId: data,
      };
    case ERROROBJ:
      return {
        ...state,
        errorPop: data,
      };
    case ERRORPOPMSG:
      return {
        ...state,
        errorPopMsg: data,
      };
    case LANGUAGEID:
      return {
        ...state,
        languageId: data,
      };
    case SELECTLANG:
      return {
        ...state,
        selectLang: data,
      };
    case SELECTLANGJSON:
      return {
        ...state,
        selectLangJson: data,
      };
    case LANGUAGES:
      return {
        ...state,
        languages: data,
      };
    case PROFILEUPDATE:
      return {
        ...state,
        profileUpdate: data,
      };
    case PROFILEDATA:
      return {
        ...state,
        profileData: data,
      };
    case PROFILEDETAIL:
      return {
        ...state,
        profileDetail: data,
      };
    case ONBAORDING:
      return {
        ...state,
        isOnBoardingSet: data,
      };

    case NEWUSER:
      return {
        ...state,
        newUser: data,
      };
    case LANGUAGEDATA:
      return {
        ...state,
        languageData: data,
      };
    case DEFAULTLANGUAGE:
      return {
        ...state,
        defaultLanguage: data,
      };
    case ISCOMPLETESTATUS:
      return {
        ...state,
        isCompleteStatus: data,
      };
    default:
      return state;
  }
};

export default customReducer;
